module.exports = __webpack_public_path__ + "img/vip_icon3@3x.1faafb5d.png";